export const HEALTH_PROGRAMS = {
  PCOS: "pcos",
  HYPERTENSION: "hypertension",
  THYROID: "thyroid",
  PRENATAL: "prenatal",
  POSTNATAL: "postnatal",
};
export const getBannerData = (programType) => {
  switch (programType) {
    case HEALTH_PROGRAMS.PCOS:
      return {
        banner: "pcos.png",
        heading: "PCOS symptoms can be reversed! ",
        subheading:
          "The right nutrition and exercise plan can show you effects within 6 months!",
        ctaText: "Introductory offer at INR",
        price: "7,500",
        old_price: "12,500",
      };
    case HEALTH_PROGRAMS.HYPERTENSION:
      return {
        banner: "pcos.png",
        heading: "Hypertention can be reversed!",
        subheading:
          "The right nutrition and exercise plan can show you effects within 6 months!",
        ctaText: [],
      };
    case HEALTH_PROGRAMS.THYROID:
      return {
        banner: "pcos.png",
        heading: "Thyroid Conditions can be reversed!",
        subheading:
          "The right nutrition and exercise plan can show you effects within 6 months!",
        ctaText: [],
      };
    case HEALTH_PROGRAMS.PRENATAL:
      return {
        banner: "pcos.png",
        heading: "Prenatal",
        subheading:
          "The right nutrition and exercise plan can show you effects within 6 months!",
        ctaText: [],
      };
    case HEALTH_PROGRAMS.POSTNATAL:
      return {
        banner: "pcos.png",
        heading: "Postnatal",
        subheading:
          "The right nutrition and exercise plan can show you effects within 6 months!",
        ctaText: [],
      };
    default:
      return {
        banner: "pcos.png",
        heading: "PCOS symptoms can be reversed!",
        subheading:
          "The right nutrition and exercise plan can show you effects within 6 months!",
        ctaText: "Introductory offer at INR",
        price: "7,500",
        old_price: "12,500",
      };
  }
};
export const getHowItWorksData = (programType) => {
  switch (programType) {
    case HEALTH_PROGRAMS.PCOS:
      return {
        HOW_IT_WORKS_LIST: [
          {
            text: "A PCOS coach will be available 24x7 to help you adhere to the program",
          },
          {
            text: "Scheduled Nutrition consultations every fortnight",
          },
          {
            text: "Live, interactive yoga & exercise sessions with experienced coaches",
          },
          {
            text: "Live Mindfulness sessions for stress relief",
          },
          {
            text: "Access to doctors if needed",
          },
        ],
      };
    case HEALTH_PROGRAMS.HYPERTENSION:
      return {
        HOW_IT_WORKS_LIST: [
          {
            text: "Hyper A PCOS coach will be available 24x7 to help you adhere to the program",
          },
          {
            text: "Scheduled Nutrition consultations every fortnight",
          },
          {
            text: "Live, interactive yoga & exercise sessions with experienced coaches",
          },
          {
            text: "Live Mindfulness sessions for stress relief",
          },
          {
            text: "Access to doctors if needed",
          },
        ],
      };
    case HEALTH_PROGRAMS.THYROID:
      return {
        HOW_IT_WORKS_LIST: [
          {
            text: "Hyper A PCOS coach will be available 24x7 to help you adhere to the program",
          },
          {
            text: "Scheduled Nutrition consultations every fortnight",
          },
          {
            text: "Live, interactive yoga & exercise sessions with experienced coaches",
          },
          {
            text: "Live Mindfulness sessions for stress relief",
          },
          {
            text: "Access to doctors if needed",
          },
        ],
      };
    case HEALTH_PROGRAMS.PRENATAL:
      return {
        HOW_IT_WORKS_LIST: [
          {
            text: "Hyper A PCOS coach will be available 24x7 to help you adhere to the program",
          },
          {
            text: "Scheduled Nutrition consultations every fortnight",
          },
          {
            text: "Live, interactive yoga & exercise sessions with experienced coaches",
          },
          {
            text: "Live Mindfulness sessions for stress relief",
          },
          {
            text: "Access to doctors if needed",
          },
        ],
      };
    case HEALTH_PROGRAMS.POSTNATAL:
      return {
        HOW_IT_WORKS_LIST: [
          {
            text: "Hyper A PCOS coach will be available 24x7 to help you adhere to the program",
          },
          {
            text: "Scheduled Nutrition consultations every fortnight",
          },
          {
            text: "Live, interactive yoga & exercise sessions with experienced coaches",
          },
          {
            text: "Live Mindfulness sessions for stress relief",
          },
          {
            text: "Access to doctors if needed",
          },
        ],
      };
    default:
      return {
        HOW_IT_WORKS_LIST: [
          {
            text: "A PCOS coach will be available 24x7 to help you adhere to the program",
          },
          {
            text: "Scheduled Nutrition consultations every fortnight",
          },
          {
            text: "Live, interactive yoga & exercise sessions with experienced coaches",
          },
          {
            text: "Live Mindfulness sessions for stress relief",
          },
          {
            text: "Access to doctors if needed",
          },
        ],
      };
  }
};
export const getSymptomsData = (programType) => {
  switch (programType) {
    case HEALTH_PROGRAMS.PCOS:
      return {
        question: "What is PolyCystic Ovary Syndrome?",
        answer:
          "It is a commonly occuring health condition in women caused by hormonal imbalances. Women suffering from PCOS typically produce higher levels of Insulin and Androgens (male hormones).",
        subtext: "Common symptoms in PCOS",
        HEALTH_CONDITIONS: [
          {
            img: "icon-calendar-health",
            text: "Irregular Periods",
          },
          {
            img: "icon-weight-gain",
            text: "Weight Gain",
          },
          {
            img: "icon-acne",
            text: "Acne",
          },
          {
            img: "icon-genetials",
            text: "Fertility Issues",
          },
          {
            img: "icon-anxiety",
            text: "Stress & Anxiety",
          },
          {
            img: "icon-hairs",
            text: "Excessive Hair Growth",
          },
        ],
      };
    case HEALTH_PROGRAMS.HYPERTENSION:
      return {
        question: "What is Hypertension?",
        answer:
          "One of the most dangerous things about hypertension -- or high blood pressure -- is that you may not know you have it. In fact, nearly one-third of people who have high blood pressure don't know it. That's because high blood pressure doesn't have any symptoms unless it's very severe.",
        subtext: "Common symptoms in Hypertension",
        HEALTH_CONDITIONS: [
          {
            img: "icon-headache",
            text: "Severe Headaches",
          },
          {
            img: "icon-nose-bleed",
            text: "Nosebleed",
          },
          {
            img: "icon-fatigue",
            text: "Fatigue or Confusion",
          },
          {
            img: "icon-chest-pain",
            text: "Chest Pain",
          },
          {
            img: "icon-breath",
            text: "Difficulty in Breathing",
          },
          {
            img: "icon-heart-graph",
            text: "Irregular Heartbeat or Palpitations",
          },
        ],
      };
    case HEALTH_PROGRAMS.THYROID:
      return {
        question: "What is Thyroid?",
        answer:
          "It is a commonly occuring health condition inYour thyroid is a butterfly-shaped gland in your neck, just above your collarbone. It is one of your endocrine glands, which make hormones. Thyroid hormones control the rate of many activities in your body. These include how fast you burn calories and how fast your heart beats. All of these activities are your body's metabolism. women caused by hormonal imbalances. Women suffering from PCOS typically produce higher levels of Insulin and Androgens (male hormones).",
        subtext: "Common symptoms in Thyroid",
        HEALTH_CONDITIONS: [
          {
            img: "icon-weight-gain",
            text: "Weight Gain",
          },
          {
            img: "icon-fatigue",
            text: "Fatigue",
          },
          {
            img: "icon-hair-loss",
            text: "Hair Loss",
          },
          {
            img: "icon-stomach",
            text: "Constipation",
          },
          {
            img: "icon-mental",
            text: "Depression",
          },
          {
            img: "icon-dry-skin",
            text: "Dry Skin or Pale and Puffy Face",
          },
        ],
      };
    case HEALTH_PROGRAMS.PRENATAL:
      return {
        question: "What is Prenatal",
        answer:
          "It is a commonly occuring health condition in women caused by hormonal imbalances. Women suffering from PCOS typically produce higher levels of Insulin and Androgens (male hormones).",
        subtext: "Common symptoms in Prenatal",
        HEALTH_CONDITIONS: [
          {
            img: "icon-zero-figure",
            text: "Difficulty regaining pre-pregnancy shape",
          },
          {
            img: "icon-fatigue",
            text: "Exhaustion",
          },
          {
            img: "icon-back-ache",
            text: "Backache",
          },
          {
            img: "icon-mental",
            text: "Maternal Depression",
          },
          {
            img: "icon-heart-graph",
            text: "Reduces risk of cardiovascular diseases & diabetes",
          },
        ],
      };
    case HEALTH_PROGRAMS.POSTNATAL:
      return {
        question: "What is Postnatal",
        answer:
          "It is a commonly occuring health condition in women caused by hormonal imbalances. Women suffering from PCOS typically produce higher levels of Insulin and Androgens (male hormones).",
        subtext: "Common symptoms in Prenatal",
        HEALTH_CONDITIONS: [
          {
            img: "icon-zero-figure",
            text: "Difficulty regaining pre-pregnancy shape",
          },
          {
            img: "icon-fatigue",
            text: "Exhaustion",
          },
          {
            img: "icon-back-ache",
            text: "Backache",
          },
          {
            img: "icon-mental",
            text: "Maternal Depression",
          },
          {
            img: "icon-heart-graph",
            text: "Reduces risk of cardiovascular diseases & diabetes",
          },
        ],
      };
    default:
      return {
        question: "What is PolyCystic Ovary Syndrome?",
        answer:
          "It is a commonly occuring health condition in women caused by hormonal imbalances. Women suffering from PCOS typically produce higher levels of Insulin and Androgens (male hormones).",
        subtext: "Common symptoms in PCOS",
        HEALTH_CONDITIONS: [
          {
            img: "icon-calendar-health",
            text: "Irregular Periods",
          },
          {
            img: "icon-weight-gain",
            text: "Weight Gain",
          },
          {
            img: "icon-acne",
            text: "Acne",
          },
          {
            img: "icon-genetials",
            text: "Fertility Issues",
          },
          {
            img: "icon-anxiety",
            text: "Stress & Anxiety",
          },
          {
            img: "icon-hairs",
            text: "Excessive Hair Growth",
          },
        ],
      };
  }
};
export const getCardsData = (programType) => {
  switch (programType) {
    case HEALTH_PROGRAMS.PCOS:
      return {
        card_title: "Our packages",
        card_subtitle: "",
        CARDS: [
          {
            cardColor: "blue",
            package_duration: "3 months plan",
            price: "9,500",
            old_price: "13,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
          {
            cardColor: "purple",
            package_duration: "3 months plan",
            price: "9,500",
            old_price: "13,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
        ],
      };
    case HEALTH_PROGRAMS.HYPERTENSION:
      return {
        card_title: "Our packages",
        card_subtitle: "",
        CARDS: [
          {
            cardColor: "blue",
            package_duration: "3 months plan",
            price: "9,500",
            old_price: "13,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
          {
            cardColor: "purple",
            package_duration: "3 months plan",
            price: "9,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
        ],
      };
    case HEALTH_PROGRAMS.THYROID:
      return {
        card_title: "Our packages",
        card_subtitle: "",
        CARDS: [
          {
            cardColor: "green",
            package_duration: "3 months plan",
            price: "9,500",
            old_price: "13,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vulputate cursus justo,eget dictum dolor posuere ut. ",
          },
          {
            cardColor: "purple",
            package_duration: "3 months plan",
            price: "9,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
        ],
      };
    case HEALTH_PROGRAMS.PRENATAL:
      return {
        card_title: "Our packages",
        card_subtitle: "",
        CARDS: [
          {
            cardColor: "blue",
            package_duration: "3 months plan",
            price: "9,500",
            old_price: "13,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
          {
            cardColor: "purple",
            package_duration: "3 months plan",
            price: "9,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
        ],
      };
    case HEALTH_PROGRAMS.POSTNATAL:
      return {
        card_title: "We have a waitlist on our packages!",
        card_subtitle:
          "Sorry we can't sell a package right now as we are not able to cater to the demand. You can pay us a refundable fee to pre-book a discounted price and we will call you asap! ",
        CARDS: [
          {
            cardColor: "blue",
            package_duration: "3 months plan",
            price: "9,500",
            old_price: "13,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Etiam vulputate cursus justo, eget dictum dolor posuere ut.",
          },
          {
            cardColor: "purple",
            package_duration: "3 months plan",
            price: "9,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
        ],
      };
    default:
      return {
        card_title: "Our packages",
        card_subtitle: "",
        CARDS: [
          {
            cardColor: "blue",
            package_duration: "3 months plan",
            price: "9,500",
            old_price: "13,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
          {
            cardColor: "purple",
            package_duration: "3 months plan",
            price: "9,500",
            old_price: "13,500",
            currency_symbol: "INR",
            cta_btn: "Book a slot",
            tag_text: "Pay only INR 99 to book a slot at this price",
          },
        ],
      };
  }
};
